import { useEffect } from 'react';

export default function useHandleEsc(callback) {
    useEffect(() => {
        function onClick(e) {
            if (e.code === 'Escape') {
                callback();
            }
        }

        document.addEventListener('keydown', onClick, { passive: true });
        return () => {
            document.removeEventListener('keydown', onClick, { passive: true });
        };
    }, [callback]);
}
